import React, { useState, createContext } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import DashboardPage from './component/pages/Dashboard/Dashboard';
import Sidebar from './component/pages/Dashboard/Sidebar';
import Navbar from './component/Navbar/Navbar';
import SettingPageMain from './component/pages/Dashboard/setting/pages/SettingPageMain';
import Employees from './component/Employees/Employees';
import Onboarding from './component/onboarding/onboarding';
import Holidays from './component/Holidays/Holidays';
import Attendance from './component/Attendance/Attendance';
import LeavesManagement from './component/LeavesManagment/LeavesManagment';
import Payroll from './component/Payroll/Payroll';
import Offboarding from './component/Offboarding/Offboarding';

import AuthGateway from './auth/AuthGateway';
import Login from './pages/Login';
import SsoCallback from './pages/SsoCallback';
import MicrosoftCallback from './pages/MicrosoftCallback';
import DeskDone from './pages/DeskDone';
import SetPassword from './pages/SetPassword';
import OrgSettings from './component/OrgSettings/OrgSettings';

import './App.css';

export const RefreshContext = createContext();

const ProtectedRoute = ({ children, allowedRoles }) => {
    const stored = localStorage.getItem('zTaskUserDetails');
    let userRole = 'EMPLOYEE';
    if (stored) {
        try {
            const user = JSON.parse(stored);
            const raw = user.role?.name || user.claims?.roles || user.role || 'EMPLOYEE';
            userRole = (Array.isArray(raw) ? raw[0] : raw).toString().toUpperCase();
        } catch (e) { /* keep default */ }
    }

    if (!allowedRoles.includes(userRole)) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '60vh', gap: 8 }}>
                <h1 style={{ margin: 0 }}>403 — Access denied</h1>
                <p style={{ color: '#666' }}>You do not have permission to view this page.</p>
            </div>
        );
    }
    return children;
};

const MainLayout = () => {
    const [refreshKey, setRefreshKey] = useState(0);
    const triggerRefresh = () => setRefreshKey((prevKey) => prevKey + 1);
    const mgmtRoles = ['SUPER_ADMIN', 'ADMIN', 'HR'];

    return (
        <RefreshContext.Provider value={{ triggerRefresh }}>
            <div className="app-layout">
                <Sidebar refreshKey={refreshKey} />
                <div className="main-content-area">
                    <Navbar />
                    <div className="page-content-wrapper">
                        <Routes>
                            <Route path="/" element={<DashboardPage />} />
                            <Route path="/dashboard" element={<DashboardPage />} />
                            <Route path="/organization/common-master" element={
                                <ProtectedRoute allowedRoles={mgmtRoles}>
                                    <OrgSettings />
                                </ProtectedRoute>
                            } />
                            <Route path="/org-settings" element={
                                <ProtectedRoute allowedRoles={mgmtRoles}>
                                    <OrgSettings />
                                </ProtectedRoute>
                            } />
                            <Route path="/employees" element={
                                <ProtectedRoute allowedRoles={mgmtRoles}>
                                    <Employees />
                                </ProtectedRoute>
                            } />
                            <Route path="/onboarding" element={<Onboarding />} />
                            <Route path="/holidays" element={<Holidays />} />
                            <Route path="/attendance" element={<Attendance />} />
                            <Route path="/leaves" element={<LeavesManagement />} />
                            <Route path="/payroll" element={<Payroll />} />
                            <Route path="/offboarding-exit" element={<Offboarding />} />
                            <Route path="/settings/*" element={<SettingPageMain onProfileUpdate={triggerRefresh} />} />
                        </Routes>
                    </div>
                </div>
            </div>
        </RefreshContext.Provider>
    );
};

const App = () => {
    return (
        <BrowserRouter>
            <AuthGateway>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/set-password" element={<SetPassword />} />
                    <Route path="/auth/sso-callback" element={<SsoCallback />} />
                    <Route path="/auth/microsoft-callback" element={<MicrosoftCallback />} />
                    <Route path="/auth/desk-done" element={<DeskDone />} />
                    <Route path="/*" element={<MainLayout />} />
                </Routes>
            </AuthGateway>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />
        </BrowserRouter>
    );
};

export default App;
